module.exports = __webpack_public_path__ + "static/media/tag-white.bd7a27fc.svg";